export default {
    name: 'Noumi',
    fullName: 'Noumï distribution',
    url: 'https://noumi.ca',
    author: {
        name: 'Noumï distribution',
        profile_url: 'https://noumi.ca',
    },
    contacts: {
        address: '17 Rogel-Lamoureux Suite 104, Napierville, QC',
        email: 'info.noumidistribution.com',
        phone: '(438) 883-1643',
    },
    socials: {
        facebook: 'https://www.facebook.com/',
        instagram: 'https://www.instagram.com/',
        twitter: 'https://twitter.com/',
        youtube: 'https://www.youtube.com/',
    },
};
